import React from 'react';
import styled from 'styled-components';
import servicesIconsMap from 'routes/checkoutPage/constants/servicesIconsMap';
import {
  LUGGAGE as LUGGAGE_SERVICE,
  CABIN_LUGGAGE as CABIN_LUGGAGE_SERVICE,
  PRIORITY_BUNDLE as PRIORITY_BUNDLE_SERVICE,
  MEAL as MEAL_SERVICE,
} from 'routes/checkoutPage/constants/servicesKeys';
import UpgradeComponent from './UpgradeComponent';

function UpgradeTypesComponent({ type, price, description }) {
  return (
    <Root>
      {type && type === PRIORITY_BUNDLE_SERVICE && (
        <UpgradeComponent description={description} price={price} icon={servicesIconsMap[PRIORITY_BUNDLE_SERVICE]} />
      )}
      {type && type === CABIN_LUGGAGE_SERVICE && (
        <UpgradeComponent description={description} price={price} icon={servicesIconsMap[CABIN_LUGGAGE_SERVICE]} />
      )}
      {type && type === LUGGAGE_SERVICE && (
        <UpgradeComponent description={description} price={price} icon={servicesIconsMap[LUGGAGE_SERVICE]} />
      )}
      {type && type === MEAL_SERVICE && (
        <UpgradeComponent description={description} price={price} icon={servicesIconsMap[MEAL_SERVICE]} />
      )}
    </Root>
  );
}

export default UpgradeTypesComponent;

const Root = styled.div``;
